import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var DashIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M1 15h30v2H1z" }))); };

export { DashIcon as default };
